module.exports = __webpack_public_path__ + "./images/a8148c4b80901e7b20aa170cc0af032b.webp";